import { createContext, useContext, useState, useEffect } from 'react';
import adminJSONen from 'public/locales/en/admin.json'
import { useCookies } from 'react-cookie';

const LanguageContext = createContext();

export const useLanguage = () => {
  return useContext(LanguageContext);
};

export const LanguageProvider = ({ children }) => {

  const [adminLanguageLoaded, setAdminLanguageLoaded] = useState(false);
  const [cookies, setCookie] = useCookies(['lang']);

  // New state for customerID
  const [customerID, setCustomerID] = useState(null);

  // Check for customerID in URL parameters or local storage
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlCustomerID = urlParams.get('customerID');
    if (urlCustomerID) {
      localStorage.setItem('customerID', urlCustomerID);
      setCustomerID(urlCustomerID);
    } else {
      const storedCustomerID = localStorage.getItem('customerID');
      if (storedCustomerID) {
        setCustomerID(storedCustomerID);
      }
    }
  }, []);

  useEffect(() => {
    if (!cookies.lang) {
      let lang = navigator.language.split('-')[0];
      if (!lang) {
        return;
      }
      setCookie('lang', lang, { path: '/' });
    }
  }, []);

  const [adminLanguage, setAdminLanguage] = useState(adminJSONen);
  const [adminLanguageCode, setAdminLanguageCode] = useState(cookies.lang ? cookies.lang : "en");

  useEffect(() => {
    fetch(`/api/language?languageCode=${adminLanguageCode}&target=admin`)
      .then(res => res.json())
      .then(data => {
        setAdminLanguage(data);
        setAdminLanguageLoaded(true);
      });
  }, []);

  const [widgetLanguageCode, setWidgetLanguageCode] = useState(cookies.lang ? cookies.lang : "en");
  const [widgetLanguage, setWidgetLanguage] = useState("");

  useEffect(() => {
    fetch(`/api/language?languageCode=${widgetLanguageCode}&target=widget`)
      .then(res => res.json())
      .then(data => {
        setWidgetLanguage(data);
      });
  }, [widgetLanguageCode]);

  function adminLanguageCodeHandler(languageCode) {
    setAdminLanguageCode(languageCode);
    // Save the language code to the cookie
    setCookie('lang', languageCode, { path: '/' });
    // Save the language code to local storage
    localStorage.setItem('selectedAdminLanguageCode', languageCode.toString());

    fetch(`/api/language?languageCode=${languageCode}&target=admin`)
      .then(res => res.json())
      .then(data => {
        setAdminLanguage(data);
      });
  }

  function widgetLanguageCodeHandler(languageCode) {
    setWidgetLanguageCode(languageCode);
  }

  function saveSelectedAdminLanguageCode(adminLanguageCode) {
    localStorage.setItem('selectedAdminLanguageCode', adminLanguageCode.toString());
  }
  function getSelectedAdminLanguageCode() {
    return localStorage.getItem('selectedAdminLanguageCode');
  }
  function saveSelectedWidgetLanguageCode(widgetLanguageCode) {
    localStorage.setItem('selectedWidgetLanguageCode', widgetLanguageCode.toString());
  }
  function getSelectedWidgetLanguageCode() {
    return localStorage.getItem('selectedWidgetLanguageCode');
  }

  // New functions for customerID management
  function saveCustomerID(id) {
    localStorage.setItem('customerID', id);
    setCustomerID(id);
  }
  function getCustomerID() {
    return localStorage.getItem('customerID');
  }

  return (
    <LanguageContext.Provider
      value={{
        adminLanguage,
        adminLanguageCode,
        setAdminLanguageCode,
        saveSelectedAdminLanguageCode,
        getSelectedAdminLanguageCode,
        widgetLanguage,
        widgetLanguageCode,
        setWidgetLanguageCode,
        saveSelectedWidgetLanguageCode,
        getSelectedWidgetLanguageCode,
        adminLanguageLoaded,
        adminLanguageCodeHandler,
        // Expose customerID and related functions
        customerID,
        saveCustomerID,
        getCustomerID,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
